import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState } from "react";
import { PaginationProps } from "antd/es/pagination";

import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "@/utils/constants";
import { message } from "antd";
import { stockEntryService, IStockEntryFields, ITotalVo } from "./stockEntryService"
import { transPgToPagination } from "@/utils/utils";


export const useStockEntryModel = createModel(function () {
    const initSearchParam: IStockEntryFields = {};
    const initDataSource: IStockEntryFields[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ITotalVo = { InTotal: 0, totalNum: 0 }

    //查询条件
    const [searchParam, setSearchParam] = useState<IStockEntryFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IStockEntryFields[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //列表数据源分页参数
    //单据汇总
    const [descTotal, setDescTotal] = useState<ITotalVo>(initDesc);

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IStockEntryFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
    }
    const loadData = async (page?: ISearchPage, searchValue: IStockEntryFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await stockEntryService.page(searchParams);
        const { stock, totalVo } = retData[0];
        const { records, ...pg } = stock
        let newPg = { ...pg, pageNum: pg.current }
        setDescTotal(totalVo)
        setPgCfg(transPgToPagination(newPg));
        setDataSource(records ?? []);
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        descTotal,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        setDescTotal
    }
});